<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text=""
      back-button-text="Sebelumnya"
      next-button-text="Selanjutnya"
      class="steps-transparent mb-3"
      @on-complete="submitForm"
      ref="form"
    >
      <!-- account detail tab -->
      <tab-content
        title="Data Diri"
        icon="feather icon-user"
        :before-change="validationFormDataDiri"
      >
        <validation-observer
          ref="dataDiriRules"
          tag="form"
        >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
             Keadaan Diri
            </h5>
            <small class="text-muted">
              Isilah data diri Anda di bawah ini sesuai dengan keadaan diri Anda
            </small>
          </b-col>  
          <b-col md="12">
          <!-- media -->
          <b-media no-body  class="mb-2">
            <b-media-aside>
              <b-link>
                <b-img
                  ref="previewEl"
                  rounded
                  :src="foto"
                  height="80"
                  :key="reloadImg"
                />
              </b-link>
              <!--/ avatar -->
            </b-media-aside>

            <b-media-body class="mt-75 ml-75">
              <!-- upload button -->
              <b-button
                variant="primary"
                size="sm"
                class="mb-75 mr-75"
                @click="$refs.refInputEl.$el.click()"
                :disabled="true"
              >
                Unggah Foto
              </b-button>
              <b-form-file
                ref="refInputEl"
                v-model="filePhoto"
                accept=".jpg, .png, .gif"
                :hidden="true"
                plain
                @change="onFileSelected"
              />
              <!--/ upload button -->

              <!-- reset -->
              <b-button
                variant="outline-secondary"
                size="sm"
                class="mb-75 mr-75"
                :disabled="true"
              >
                Reset
              </b-button>
              <!--/ reset -->
              <div>tipe file yang diperbolehkan JPG, GIF atau PNG, ukuran 200px x 200px dan besar file maksimal 5MB</div>
            </b-media-body>
          </b-media>
          <!--/ media -->
        
          </b-col>
          <b-col md="6">
            <!-- Nama Lengkap -->
            <b-form-group
              id="nama_lengkap"
              label="Nama Lengkap *"
              label-for="nama_lengkapInput"
              invalid-feedback="Nama Lengkap harus diisi"
            >
              <validation-provider
                #default="{ errors }"
                name="Nama Lengkap *"
              >
                <b-form-input
                  v-model="form.nama_lengkap"
                  id="nama_lengkapInput"
                :disabled="true"  
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
              <!-- Nomor Ujian -->
              <b-form-group
                id="nomor_ujian"
                label="Nomor Ujian"
                label-for="nomor_ujianInput"
                invalid-feedback="Nomor Ujian harus diisi dengan angka"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nomor Ujian *"
                >
                  <b-form-input
                    v-model="form.nomor_ujian"
                    id="nomor_ujianInput"
                    readonly
                    type="number"
                    pattern="\d*"
                  :disabled="true"  
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Tempat Lahir -->
              <b-form-group
                id="tempat_lahir"
                label="Tempat Lahir *"
                label-for="tempat_lahirInput"
                invalid-feedback="Tempat Lahir harus diisi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tempat Lahir"
                >
                  <b-form-input
                    v-model="form.tempat_lahir"
                    id="tempat_lahirInput"
                  :disabled="true"  
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Tanggal Lahir -->
              <b-form-group
                id="tanggal_lahir"
                label="Tanggal Lahir *"
                label-for="tanggal_lahirInput"
                invalid-feedback="Tanggal Lahir harus diisi"
             >
                <validation-provider
                  #default="{ errors }"
                  name="Tanggal Lahir"
                >
                  <flat-pickr
                    v-model="form.tanggal_lahir"
                    :config="flatpickrConfig"
                    placeholder="Pilih tanggal"
                    class="form-control"
                    
                  ></flat-pickr>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Jenis Kelamin -->
              <b-form-group
                id="jenis_kelamin_id"
                label="Jenis Kelamin *"
                label-for="jenis_kelamin_idInput"
                invalid-feedback="Jenis Kelamin harus dipilih"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jenis Kelamin"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-select
                    v-model="form.jenis_kelamin_id"
                    id="jenis_kelamin_idInput"
                    required
                  >
                    <b-form-select-option value="1">Laki-laki</b-form-select-option>
                    <b-form-select-option value="2">Perempuan</b-form-select-option>
                  </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Alamat tempat tinggal -->
              <b-form-group
                id="alamat_tempat_tinggal"
                label="Alamat tempat tinggal *"
                label-for="alamat_tempat_tinggalInput"
                invalid-feedback="Alamat harus diisi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Alamat tempat tinggal"
                >
                  <b-form-input
                    v-model="form.alamat_tempat_tinggal"
                    id="alamat_tempat_tinggalInput"
                  :disabled="true"  
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Nomor Telepon yang bisa dihubungi -->
              <b-form-group
                id="nomor_hp"
                label="Nomor Telepon yang bisa dihubungi *"
                label-for="nomor_hpInput"
                invalid-feedback="Nomor Telepon harus diisi dengan format yang benar (minimal 10 digit)"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nomor Telepon yang bisa dihubungi"
                >
                  <b-form-input
                    v-model="form.nomor_hp"
                    id="nomor_hpInput"
                    pattern="[0-9]{10,}"
                  :disabled="true"  
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <!-- Alamat Orangtua / Wali -->
              <b-form-group
                id="alamat_orang_tua"
                label="Alamat Orangtua / Wali *"
                label-for="alamat_orang_tuaInput"
                invalid-feedback="Alamat Orangtua / Wali harus diisi"
              > 
                <validation-provider
                  #default="{ errors }"
                  name="Alamat Orangtua / Wali"
                >
                  <b-form-input
                    v-model="form.alamat_orang_tua"
                    id="alamat_orang_tuaInput"
                  :disabled="true"  
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12" style="display:none">
              <b-form-group
                id="status_pra_profesi"
                label="Apakah pernah mengikuti kegiatan Pra-profesi ni sebelumnya?"
                label-for="status_pra_profesiInput"
                invalid-feedback="Pilih salah satu opsi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Apakah pernah mengikuti kegiatan Pra-profesi ni sebelumnya?"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-radio-group
                    v-model="form.status_pra_profesi"
                    id="status_pra_profesiInput"
                    :options="status_pra_profesiOptions"
                    required
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Pernah dirawat intensif di RS karena sakit? -->
              <b-form-group
                id="pernah_dirawat"
                label="Pernah dirawat intensif di RS karena sakit?"
                label-for="pernah_dirawatInput"
                invalid-feedback="Pilih salah satu opsi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Pernah dirawat intensif di RS karena sakit?"
                >
                  <b-form-radio-group
                    v-model="form.pernah_dirawat"
                    id="pernah_dirawatInput"
                    :options="pernah_dirawatOptions"
                    
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="showPeminatan === 'true'">
              <!-- Peminatan (Spesialisasi) -->
              <b-form-group
                id="peminatan"
                label="Peminatan (Spesialisasi)"
                label-for="peminatanInput"
                description="Pilih bidang peminatan psikologi Anda"
              >
                <b-form-select
                  v-model="form.peminatan_spesialisasi"
                  id="peminatanInput"
                  :options="peminatanOptions"
                  :disabled="true"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Jika Pernah dirawat, sebutkan penyakit penyakit -->
              <b-form-group
                v-if="form.pernah_dirawat === 'Pernah'"
                id="penyakit"
                label="Jika Pernah, sebutkan penyakit penyakit tersebut"
                label-for="penyakitInput"
                invalid-feedback="penyakit harus diisi jika pernah dirawat"
              >
                <b-form-textarea
                  v-model="form.penyakit"
                  id="penyakitInput"
                  
                :disabled="true"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Apakah pernah mendapatkan pemeriksaan psikologis bagi diri Anda sendiri? -->
              <b-form-group
                id="pernah_periksa_psikologis"
                label="Apakah pernah mendapatkan pemeriksaan psikologis bagi diri Anda sendiri?"
                label-for="pernah_periksa_psikologisInput"
                invalid-feedback="Pilih salah satu opsi"
              >
                <b-form-radio-group
                  v-model="form.pernah_periksa_psikologis"
                  id="pernah_periksa_psikologisInput"
                  :options="pernah_periksa_psikologisOptions"
                  
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Jika Pernah, Jika pernah, dimana -->
              <b-form-group
                v-if="form.pernah_periksa_psikologis === 'Pernah'"
                id="tempat_periksa"
                label="Jika Pernah, dimana?"
                label-for="tempat_periksaInput"
                invalid-feedback="Tempat pemeriksaan harus diisi"
               >
                <b-form-input
                  v-model="form.tempat_periksa"
                  id="tempat_periksaInput"
                :disabled="true"  
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Jika Pernah, tambahkan kolom dimana dan kapan? -->
              <b-form-group
                v-if="form.pernah_periksa_psikologis === 'Pernah'"
                id="durasi"
                label="Bilamana (perkiraan bulan/tahun)"
                label-for="durasiInput"
                invalid-feedback="Waktu pemeriksaan harus diisi"
              >
                <b-form-input
                  v-model="form.durasi"
                  id="durasiInput"
                :disabled="true"  
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Untuk keperluan -->
              <b-form-group
                v-if="form.pernah_periksa_psikologis === 'Pernah'"
                id="keperluan"
                label="Untuk keperluan"
                label-for="keperluanInput"
                invalid-feedback="Keperluan harus diisi"
              >
                <b-form-input
                  v-model="form.keperluan"
                  id="keperluanInput"
                :disabled="true"  
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">  
              <!-- Status perkawinan -->
              <b-form-group
                id="status_perkawinan"
                label="Status perkawinan"
                label-for="status_perkawinanInput"
                invalid-feedback="Pilih salah satu opsi"
              >
                <b-form-radio-group
                  v-model="form.status_perkawinan"
                  id="status_perkawinanInput"
                  :options="status_perkawinanOptions"
                  
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details -->
      <tab-content
        title="Keluarga"
        icon="feather icon-users"
        :before-change="validationFormDataKeluarga"
        >
        <validation-observer
          ref="dataKeluargaRules"
          tag="form"
        >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Keadaan Keluarga
            </h5>
            <small class="text-muted">
              Isilah data diri Anda di bawah ini sesuai dengan keadaan diri Anda
            </small>
          </b-col>  
          <b-col cols="6">
            <!-- Nama Ayah -->
            <b-form-group
              id="nama_ayah"
              label="Nama Ayah *"
              label-for="nama_ayahInput"
              invalid-feedback="Nama Ayah harus diisi"
            >
              <validation-provider
                #default="{ errors }"
                name="Nama Ayah"
              >
                <b-form-input
                  v-model="form.nama_ayah"
                  id="nama_ayahInput"
                :disabled="true"  
                ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Usia Ayah -->
            <b-form-group
              id="usia_ayah"
              label="Usia Ayah *"
              label-for="usia_ayahInput"
            >
              <validation-provider
                #default="{ errors }"
                name="Usia Ayah"
              >
                <b-form-input
                  v-model="form.usia_ayah"
                  id="usia_ayahInput"
                  type="number"
                :disabled="true"  
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Pendidikan Ayah -->
            <b-form-group
              id="pendidikan_ayah"
              label="Pendidikan Ayah *"
              label-for="pendidikan_ayahInput"
              invalid-feedback="Pendidikan Ayah harus dipilih"
            >
              <validation-provider
                #default="{ errors }"
                name="Pendidikan Ayah"
              >
              <b-form-select
                v-model="form.pendidikan_ayah"
                id="pendidikan_ayahInput"
                :options="pendidikanOptions"
              :disabled="true"  
              ></b-form-select>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Pekerjaan Ayah -->
            <b-form-group
              id="pekerjaanAyah"
              label="Pekerjaan Ayah *"
              label-for="pekerjaanAyahInput"
            >
              <validation-provider
                #default="{ errors }"
                name="Pekerjaan Ayah"
              >
              <b-form-input
                v-model="form.pekerjaan_ayah"
                id="pekerjaanAyahInput"
              :disabled="true"  
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="12">
            <!-- Keterangan Lain Ayah -->
            <b-form-group
              id="keterangan_lain_ayah"
              label="Keterangan Lain tentang Ayah"
              label-for="keterangan_lain_ayahInput"
            >
              <b-form-textarea
                v-model="form.keterangan_lain_ayah"
                id="keterangan_lain_ayahInput"
                
              :disabled="true"
              
              ></b-form-textarea>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Nama Ayah -->
            <b-form-group
              id="nama_ibu"
              label="Nama Ibu *"
              label-for="nama_ibuInput"
              invalid-feedback="Nama Ibu harus diisi"
            >
              <validation-provider
                #default="{ errors }"
                name="Nama Ibu"
              >
              <b-form-input
                v-model="form.nama_ibu"
                id="nama_ibuInput"
              :disabled="true"  
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Usia Ibu -->
            <b-form-group
              id="usia_ibu"
              label="Usia Ibu *"
              label-for="usia_ibuInput"
            >
              <validation-provider
                #default="{ errors }"
                name="Usia Ibu"
              >
                <b-form-input
                  v-model="form.usia_ibu"
                  id="usia_ibuInput"
                  type="number"
                :disabled="true"  
                ></b-form-input>
               <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Pendidikan Ibu -->
            <b-form-group
              id="pendidikan_ibu"
              label="Pendidikan Ibu *"
              label-for="pendidikan_ibuInput"
              invalid-feedback="Pendidikan Ibu harus dipilih"
            >
              <validation-provider
                #default="{ errors }"
                name="Pendidikan Ibu"
              >
                <b-form-select
                  v-model="form.pendidikan_ibu"
                  id="pendidikan_ibuInput"
                  :options="pendidikanOptions"
                :disabled="true"  
                ></b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="6">
            <!-- Pekerjaan Ibu -->
            <b-form-group
              id="pekerjaanIbu"
              label="Pekerjaan Ibu *"
              label-for="pekerjaanIbuInput"
            >
              <validation-provider
                #default="{ errors }"
                name="Pekerjaan Ibu"
                
              >
                <b-form-input
                  v-model="form.pekerjaan_ibu"
                :disabled="true"  id="pekerjaanIbuInput"
                ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>  
          <b-col cols="12">
            <!-- Keterangan Lain Ibu -->
            <b-form-group
              id="keterangan_lain_ibu"
              label="Keterangan Lain tentang Ibu"
              label-for="keterangan_lain_ibuInput"
            >
              <b-form-textarea
                v-model="form.keterangan_lain_ibu"
                id="keterangan_lain_ibuInput"
              :disabled="true"
              
              ></b-form-textarea>
            </b-form-group>
          </b-col>
       
          <b-col cols="6">
            <b-form-group
              id="posisiKelahiran"
              label="Posisi Kelahiran Anda (Anak Ke dan Dari Berapa Bersaudara)"
              label-for="posisiKelahiranInput"
            >
              <b-row>
                <b-col>
                  <b-form-group
                    id="anda_anak_ke"
                    label="Anak Ke *"
                    label-for="anda_anak_keInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Anak Ke"
                      
                    >
                      <b-form-input
                        v-model="form.anda_anak_ke"
                        id="anda_anak_keInput"
                        type="number"
                      :disabled="true"  
                      ></b-form-input>
                     <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="anda_dari_berapa_bersaudara"
                    label="Dari *"
                    label-for="anda_dari_berapa_bersaudaraInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Dari"
                      
                    >
                    <b-form-input
                      v-model="form.anda_dari_berapa_bersaudara"
                      id="anda_dari_berapa_bersaudaraInput"
                    :disabled="true"  type="number"
                    ></b-form-input>
                     <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <!-- Tuliskan keadaan saudara sekandung/angkat -->
            <b-form-group
              id="keadaan_saudara_kandung"
              label="Tuliskan keadaan saudara sekandung/angkat (Urutan Kelahiran Saudara, Nama Saudara, Jenis Kelamin, Umur, Pendidikan, Pekerjaan, Keterangan (kandung/angkat/wafat))"
              label-for="keadaan_saudara_kandungInput"
            >
              <b-form-textarea
                v-model="form.keadaan_saudara_kandung"
                id="keadaan_saudara_kandungInput"
              :disabled="true"
              
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        </validation-observer>
      </tab-content>

      <!-- address -->
      <tab-content
        title="Pendidikan"
        icon="feather icon-award"
        :before-change="validationFormDataPendidikan"
      >
        <validation-observer
          ref="dataPendidikanRules"
          tag="form"
        >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Keadaan Pendidikan
            </h5>
            <small class="text-muted">
              Tuliskan Riwayat Pendidikan Anda
            </small>
          </b-col>  
        </b-row>
         <!-- Pendidikan SD -->
          <b-form-group
            id="pendidikanSD"
            label="Pendidikan SD / Setingkat"
            label-for="pendidikanSDInput"
          >
            <b-row>
              <b-col>
                <b-form-group
                  id="nama_sd"
                  label="Nama SD *"
                  label-for="nama_sdInput"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Nama SD"
                    
                  >
                    <b-form-input
                      v-model="form.nama_sd"
                    :disabled="true"  id="nama_sdInput"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="masa_pendidikan_sd"
                  label="Masa Pendidikan *"
                  label-for="masa_pendidikan_sdInput"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Masa Pendidikan SD"
                    
                  >
                    <b-form-input
                      v-model="form.masa_pendidikan_sd"
                    :disabled="true"  id="masa_pendidikan_sdInput"
                    ></b-form-input>
                   <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="status_pendidikan_sd"
                  label="Status Pendidikan"
                  label-for="status_pendidikan_sdInput"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status Pendidikan SD *"
                    
                  >
                    <b-form-select
                      v-model="form.status_pendidikan_sd"
                      id="status_pendidikan_sdInput"
                    :disabled="true"  :options="statusKelulusanOptions"
                    ></b-form-select>
                   <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form-group>

          <!-- Pendidikan SMP -->
           <b-form-group
              id="pendidikanSMP"
              label="Pendidikan SMP / Setingkat"
              label-for="pendidikanSMPInput"
            >
              <b-row>
                <b-col>
                  <b-form-group
                    id="nama_smp"
                    label="Nama SMP *"
                    label-for="nama_smpInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Nama SMP"
                      
                    >
                      <b-form-input
                        v-model="form.nama_smp"
                      :disabled="true"  id="nama_smpInput"
                      ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="masa_pendidikan_smp"
                    label="Masa Pendidikan *"
                    label-for="masa_pendidikan_smpInput"
                  > 
                    <validation-provider
                      #default="{ errors }"
                      name="Masa Pendidikan SMP"
                      
                    >
                      <b-form-input
                        v-model="form.masa_pendidikan_smp"
                      :disabled="true"  id="masa_pendidikan_smpInput"
                      ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="status_pendidikan_smp"
                    label="Status Pendidikan *"
                    label-for="status_pendidikan_smpInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Status Pendidikan SMP"
                      
                    >
                      <b-form-select
                        v-model="form.status_pendidikan_smp"
                        id="status_pendidikan_smpInput"
                      :disabled="true"  :options="statusKelulusanOptions"
                      ></b-form-select>
                     <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>

            <!-- Pendidikan SMA -->
           <b-form-group
              id="pendidikanSMA"
              label="Pendidikan SMA / Setingkat"
              label-for="pendidikanSMAInput"
            >
              <b-row>
                <b-col>
                  <b-form-group
                    id="nama_sma"
                    label="Nama SMA *"
                    label-for="nama_smaInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Nama SMA"
                      
                    >
                    <b-form-input
                      v-model="form.nama_sma"
                    :disabled="true"  id="nama_smaInput"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="masa_pendidikan_sma"
                    label="Masa Pendidikan *"
                    label-for="masa_pendidikan_smaInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Masa Pendidikan SMA"
                      
                    >
                    <b-form-input
                      v-model="form.masa_pendidikan_sma"
                    :disabled="true"  id="masa_pendidikan_smaInput"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="status_pendidikan_sma"
                    label="Status Pendidikan *"
                    label-for="status_pendidikan_smaInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Status Pendidikan SMA"
                      
                    >
                    <b-form-select
                      v-model="form.status_pendidikan_sma"
                      id="status_pendidikan_smaInput"
                    :disabled="true"  :options="statusKelulusanOptions"
                    ></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
          <b-form-group
              id="pendidikanUniversitas"
              label="Pendidikan Universitas (S1)"
              label-for="pendidikanUniverstitasInput"
            >
              <b-row>
                <b-col>
                  <b-form-group
                    id="nama_universitas"
                    label="Nama Universitas *"
                    label-for="nama_universtitasInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Nama Universitas"
                      rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                    >
                    <b-form-input
                      v-model="form.nama_universitas"
                      id="nama_universtitasInput"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="masa_pendidikan_universitas"
                    label="Masa Pendidikan *"
                    label-for="masa_pendidikan_universtitasInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Masa Pendidikan Universitas"
                      rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                    >
                    <b-form-input
                      v-model="form.masa_pendidikan_universitas"
                      id="masa_pendidikan_universtitasInput"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="ipk_pendidikan_universitas"
                    label="IPK *"
                    label-for="ipk_pendidikan_universtitasInput"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="IPK"
                      rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                    >
                    <b-form-input
                      v-model="form.ipk_pendidikan_universitas"
                      id="ipk_pendidikan_universtitasInput"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group
              id="pendidikanUniversitas"
              label="Pendidikan Universitas (S2)"
              label-for="pendidikanUniverstitasInput"
            >
              <b-row>
                <b-col>
                  <b-form-group
                    id="nama_universitass2"
                    label="Nama Universitas"
                    label-for="nama_universtitass2Input"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Nama Universitas"
                    >
                    <b-form-input
                      v-model="form.nama_universitass2"
                      id="nama_universtitass2Input"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="masa_pendidikan_universitass2"
                    label="Masa Pendidikan"
                    label-for="masa_pendidikan_universtitass2Input"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Masa Pendidikan Universitas"
                    >
                    <b-form-input
                      v-model="form.masa_pendidikan_universitass2"
                      id="masa_pendidikan_universtitass2Input"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="ipk_pendidikan_universitass2"
                    label="IPK"
                    label-for="ipk_pendidikan_universtitass2Input"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="IPK"
                    >
                    <b-form-input
                      v-model="form.ipk_pendidikan_universitass2"
                      id="ipk_pendidikan_universtitass2Input"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
          <!-- Kegiatan Pendidikan Informal -->
            <b-form-group
              id="kegiatan_informal"
              label="Kegiatan Pendidikan Informal yang Pernah Diikuti, (Jenis Kegiatan, Keterangan). Boleh lebih satu, pisahkan dengan titik koma"
              label-for="kegiatan_informalInput"
            >
              <b-form-textarea
                v-model="form.kegiatan_informal"
                id="kegiatan_informalInput"
              :disabled="true"
              
              ></b-form-textarea>
            </b-form-group>
          <!-- Unggah Ijazah Sarjana -->
          <b-row
            v-for="(value, index) in berkas"
            :key="index"
          >
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-row>
                <b-col md="6">
                  <b-form-group
                  >
                    <label><strong>{{ value.judul }}</strong> <span class="required" v-if="value.required === 1">*</span></label>
                    <validation-provider
                      #default="{ errors }"
                      :name="value.judul"
                    >
                      <div class="d-flex">
                        <b-form-file
                          ref="file-input"
                          :id="value.uuid"
                          v-model="fileBerkas[value.uuid]"
                          :value="value.dokumen"
                          accept=".pdf, .jpg, .jpeg, .png"
                          required
                        />
                        <b-button
                          v-if="value.dokumen !== null"
                          variant="success"
                          class="mb-75 mr-75 ml-1"
                          @click="lihatFile(value.dokumen.file)"
                        >
                          Lihat
                        </b-button>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <label for="">{{ value.deskripsi }}</label>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <!-- Pengalaman Penelitian -->
              <b-form-group
                id="pernah_penelitian"
                label="Apakah anda pernah melakukan penelitian ilmiah? *"
                label-for="pernah_penelitianInput"
                invalid-feedback="Pilih salah satu opsi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Pengalaman penelitian ilmiah"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-checkbox-group
                    v-model="form.pernah_penelitian"
                    id="pernah_penelitianInput"
                    :options="pernah_penelitianOptions"
                    required
                  ></b-form-checkbox-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="form.pernah_penelitian && form.pernah_penelitian.length > 0 && !form.pernah_penelitian.includes('Tidak pernah')">
              <!-- Metode Penelitian -->
              <b-form-group
                id="metode_penelitian"
                label="Jika pernah, Metode penelitian apa yang anda gunakan *"
                label-for="metode_penelitianInput"
                invalid-feedback="Pilih salah satu opsi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Metode penelitian apa yang anda gunakan"
                  :rules="{ required: form.pernah_penelitian && form.pernah_penelitian.length > 0 && !form.pernah_penelitian.includes('Tidak pernah') }"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-checkbox-group
                    v-model="form.metode_penelitian"
                    id="metode_penelitianInput"
                    :options="metode_penelitianOptions"
                    required
                  ></b-form-checkbox-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          
        </validation-observer>
      </tab-content>

      <!-- social link -->
      <tab-content
        title="Pengalaman Bekerja"
        icon="feather icon-briefcase"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Pengalaman Bekerja
            </h5>
            <small class="text-muted">
              Tuliskan Riwayat Pekerjaan Anda (bila ada)
            </small>
          </b-col>  
        </b-row>
        <div>
          <!-- Table displaying work experience -->
          <b-table striped hover :items="workExperiences" :fields="fieldsWorkExperiences">
            <template #cell(actions)="row">
              <b-button @click="confirmDeleteWorkExperience(row.item)" variant="danger" size="sm">
                Delete
              </b-button>
            </template>
          </b-table>

          <!-- Modal for adding/editing work experience -->
          <b-modal ref="myModalWorkRef" title="Tambah Pengalaman Bekerja">
            <b-form @submit.prevent="saveWorkExperience">
              <b-form-group label="Nama Perusahaan/Instansi">
                <b-form-input v-model="newWorkExperience.nama_perusahaan"></b-form-input>
              </b-form-group>
              <b-form-group label="Lama Bekerja">
                <b-form-input v-model="newWorkExperience.lama_bekerja"></b-form-input>
              </b-form-group>
              <b-form-group label="Jabatan/Posisi">
                <b-form-input v-model="newWorkExperience.jabatan_posisi"></b-form-input>
              </b-form-group>
              <b-form-group label="Deskripsi Pekerjaan">
                <b-form-textarea v-model="newWorkExperience.deskripsi_pekerjaan"
                :disabled="true"
                ></b-form-textarea>
              </b-form-group>
              <b-button type="submit">Simpan</b-button>
            </b-form>
          </b-modal>

          <!-- Button to add new work experience -->
          <b-button @click="openModalWorkExperience" variant="primary" :disabled="true">Tambah Pengalaman Bekerja</b-button>

        </div>
      </tab-content>
      <tab-content
        title="Pengalaman Kuliah"
        icon="feather icon-check"
      >   
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <!-- <h5 class="mb-0">
              Pengalaman Kuliah
            </h5>
            <small class="text-muted">
              Isilah data diri Anda di bawah ini sesuai dengan keadaan diri Anda
            </small> -->
          </b-col>  
          <b-col
            cols="6"
            class="mb-2"
            v-for="(peminatan, index) in peminatans" :key="index" >

            <b-form-group :label="peminatan.pertanyaan">
              <div v-if="peminatan.tipe === 'textarea'">
                <b-form-textarea v-model="peminatans[index].jawaban" @change="handleChangePeminatan(peminatan.uuid, peminatans[index].jawaban)" :disabled="true"></b-form-textarea>
              </div>
              <div  v-if="peminatan.tipe === 'text'">
                <b-form-input v-model="peminatans[index].jawaban" @change="handleChangePeminatan(peminatan.uuid, peminatans[index].jawaban)":disabled="true" ></b-form-input>
              </div>
              <div  v-if="peminatan.tipe === 'range'">
                <div class="d-flex justify-content-between align-items-center" v-if="peminatan.pertanyaan != 'Seberapa optimis Anda akan dapat menyelesaikan studi Anda tepat Waktu?'">
                  <div>Sangat Tidak Puas</div>
                  <div>Sangat Puas</div>
                </div>
                <div class="d-flex justify-content-between align-items-center" v-else>
                  <div>Sangat Tidak Optimis</div>
                  <div>Sangat Optimis</div>
                </div>
                <b-form-input type="range" v-model="peminatans[index].jawaban" min="1" max="10" @change="handleChangePeminatan(peminatan.uuid, peminatans[index].jawaban)" :disabled="true"></b-form-input>
                <div class="d-flex justify-content-between">
                  <div>1</div>
                  <div>10</div>
                </div>
              </div>
            </b-form-group>
          </b-col>  
        </b-row>

      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/id.js'; // Import Indonesian language pack
import {
  getLembarKehidupan,
  postPengalamanKerja,
  deletePengalamanKerja,
  updateLembarKehidupan,
  patchPeminatan,
  getBerkas,
  downloadBerkas,
  uploadFileBerkas,
  uploadFoto,
  downloadPhoto,
} from '@/connection-api/lembarkehidupan'
import {
  required,
  integer,
  regex,
  confirmed,
  min,
  max,
  email
} from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});

import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BButton,
  BFormDatepicker,
  BMedia, BMediaAside, BMediaBody,
  BFormFile,
  BImg,
  BFormSelect,
  BFormSelectOption,
  BTable,
  BLink,
} from 'bootstrap-vue';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    FlatPickr,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BButton,
    BFormDatepicker,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BMedia, BMediaAside, BMediaBody,
    BFormFile,
    BImg,
    BFormSelect,
    BFormSelectOption,
    BTable,
    BLink,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      showPeminatan: process.env.VUE_APP_PEMINATAN_SHOW || 'false',
      required,
      integer,
      regex,
      confirmed,
      min,
      max,
      email,
      profileFile: null,
      reloadImg: 0,
      fileBerkas: [],
      filePhoto: '',
      foto: '',
      form: {
        nama_lengkap: '',
        nomor_ujian: null,
        tempat_lahir: '',
        tanggal_lahir: '',
        alamat_tempat_tinggal: '',
        nomor_hp: '',
        alamat_orang_tua: '',
        pernah_dirawat: '',
        pra_profesi: '',
        jenis_kelamin_id: 1,
        peminatan_spesialisasi: '',
        penyakit: '',
        pernah_periksa_psikologis: '',
        durasi: '',
        keperluan: '',
        status_perkawinan: '',
        nama_ayah: '',
        usia_ayah: null,
        pendidikan_ayah: '',
        pekerjaan_ayah: '',
        keterangan_lain_ayah: '',
        nama_ibu: '',
        usia_ibu: null,
        pendidikan_ibu: '',
        pekerjaan_ibu: '',
        keterangan_lain_ibu: '',
        anda_anak_ke: null,
        anda_dari_berapa_bersaudara: null,
        keadaan_saudara_kandung: '',
        kegiatan_informal: '',
        pernah_penelitian: [],
        metode_penelitian: [],
      },
      status_pra_profesiOptions: ['Pernah', 'Tidak Pernah'],
      pernah_dirawatOptions: ['Pernah', 'Tidak Pernah'],
      pernah_periksa_psikologisOptions: ['Pernah', 'Tidak Pernah'],
      status_perkawinanOptions: ['Menikah', 'Tidak Menikah'],
      pendidikanOptions: ['SMA', 'S1', 'S2', 'S3', 'Lainnya'],
      statusKelulusanOptions: ['Lulus', 'Tidak Lulus', 'Pindah'],
      peminatanOptions: (process.env.VUE_APP_PEMINATAN_OPTIONS
        ? process.env.VUE_APP_PEMINATAN_OPTIONS.split(',').map(o => o.trim())
        : []
      ),
      pernah_penelitianOptions: [
        { text: 'Ya pernah, untuk skripsi/tugas akhir', value: 'Ya pernah, untuk skripsi/tugas akhir' },
        { text: 'Ya pernah, untuk proyek penelitian di luar skripsi/tugas akhir', value: 'Ya pernah, untuk proyek penelitian di luar skripsi/tugas akhir' },
        { text: 'Tidak pernah', value: 'Tidak pernah' }
      ],
      metode_penelitianOptions: [
        { text: 'Kuantitatif', value: 'Kuantitatif' },
        { text: 'Kualitatif', value: 'Kualitatif' },
        { text: 'Mix Method', value: 'Mix Method' }
      ],
      flatpickrConfig: {
        altInput: true,
        altFormat: 'j F Y', // Indonesian date format
        dateFormat: 'Y-m-d', // Actual date format used for the form
        locale: 'id', // Set locale to Indonesian
      },
      berkas: [

      ],
      workExperiences: [
        { nama_perusahaan: 'ABC Corp', lama_bekerja: '2 years', jabatan_posisi: 'Manager', deskripsi_pekerjaan: 'Job description...', uuid: '' },
        // ... other work experiences
      ],
      fieldsWorkExperiences: [
        { key: 'nama_perusahaan', label: 'Nama Perusahaan/Instansi' },
        { key: 'lama_bekerja', label: 'Lama Bekerja' },
        { key: 'jabatan_posisi', label: 'Jabatan/Posisi' },
        { key: 'deskripsi_pekerjaan', label: 'Deskripsi Pekerjaan' },
        { key: 'actions', label: 'Aksi', sortable: false },
      ],
      newWorkExperience: {
        nama_perusahaan: '',
        lama_bekerja: '',
        jabatan_posisi: '',
        deskripsi_pekerjaan: '',
        uuid: ''
      },
      peminatans: [],
      selectedWorkExperience: null,
      formData: {
        peminatan: '',
        jalurKlinis: '', // New field for Psychology Clinical Path clarification
        alasanPeminatan: '',
        ipkS1: '',
        kepuasanIPK: 5,
        alasanKepuasan: '',
        alasanKetidakpuasan: '',
        optimismeStudi: 5,
        faktorOptimisme: '',
        kendalaStudi: '',
        pengalamanTerbaik: '',
        pengalamanTerburuk: '',
        syukuriKeluarga: '',
        kurangMenyenangkanKeluarga: '',
        kepribadianPositif: '',
        kepribadianNegatif: '',
        syukuriKeluargaMenikah: '',
        kurangMenyenangkanKeluargaMenikah: '',
      },
      pilihanPeminatan: [
        'Psikologi Pendidikan',
        'Psikologi Industri dan Organisasi',
        'Psikologi Klinis (Jalur KLA)',
        'Psikologi Klinis (Jalur KLD)',
      ],
    };
  },
  mounted() {
    this.getDataLembarKehidupan();
  },
  methods: {
    async getDataLembarKehidupan() {
      const data = {
        token: this.$route.params.token,
      };
      const response = await getLembarKehidupan(data);
      if (response.data) {
        // Use object spreading to keep fields defined in data() but missing in response
        this.form = { ...this.form, ...response.data.data };

        // Ensure research experience fields are arrays (handle JSON strings if necessary)
        if (typeof this.form.pernah_penelitian === 'string') {
          try {
            this.form.pernah_penelitian = JSON.parse(this.form.pernah_penelitian);
          } catch (e) {
            this.form.pernah_penelitian = [];
          }
        }
        if (typeof this.form.metode_penelitian === 'string') {
          try {
            this.form.metode_penelitian = JSON.parse(this.form.metode_penelitian);
          } catch (e) {
            this.form.metode_penelitian = [];
          }
        }

        // Final fallback to empty array
        this.form.pernah_penelitian = this.form.pernah_penelitian || [];
        this.form.metode_penelitian = this.form.metode_penelitian || [];

        this.workExperiences = this.form.pengalaman_pekerjaan;
        this.peminatans = this.form.peminatan;
        const params = {
          filename: this.form.foto,
          token: this.$route.params.token,
        };
        const responsePhoto = await downloadPhoto(params);
        if (responsePhoto.data) {
          if(responsePhoto.data.status.code === '00'){
            this.foto = responsePhoto.data.data.img_base64;
            this.reloadImg += 1;
          }
        }
      }
      const responseBerkas = await getBerkas(data);
      if (responseBerkas.data) {
        this.berkas = responseBerkas.data.data;
      }
    },
    renderImage() {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.foto = reader.result;
        this.reloadImg += 1
      });
      reader.readAsDataURL(this.foto);
    },
    onFileSelected(event) {
      this.foto = event.target.files[0];
      this.filePhoto = event.target.files[0];
      this.renderImage();
    },
    async submitForm() {
      // const responseUpdate = await updateLembarKehidupan(this.form)
      // .then(response => {
      //   if(response.data.status.code === '01'){
      //     this.$bvModal.msgBoxOk(response.data.status.message, {
      //       title: 'Gagal',
      //       size: 'sm',
      //       buttonSize: 'sm',
      //       okVariant: 'danger',
      //       headerClass: 'p-2 border-bottom-0',
      //       footerClass: 'p-2 border-top-0',
      //       hideHeaderClose: false
      //     });
      //   }else{
      //     this.$bvModal.msgBoxOk('Data Lembar Kehidupan berhasil disimpan.', {
      //       title: 'Sukses',
      //       size: 'sm',
      //       buttonSize: 'sm',
      //       okVariant: 'success',
      //       headerClass: 'p-2 border-bottom-0',
      //       footerClass: 'p-2 border-top-0',
      //       hideHeaderClose: false
      //     });
      //   }
       
      // })
      // .catch(error => {
      //   console.error('Error:', error);
      //   this.$bvModal.msgBoxOk("Terjadi kesalahan data", {
      //     title: 'Gagal',
      //     size: 'sm',
      //     buttonSize: 'sm',
      //     okVariant: 'danger',
      //     headerClass: 'p-2 border-bottom-0',
      //     footerClass: 'p-2 border-top-0',
      //     hideHeaderClose: false
      //   });
      // });
      // Final form submission logic after completing all steps
      // This method will be called when the user completes all steps
    },
    async handleChangePeminatan(uuid, value) {
      const response = await patchPeminatan(uuid, value); 
    },
    openModalWorkExperience() {
      this.$refs.myModalWorkRef.show();
    },
    async saveWorkExperience() {
      // Add the new work experience to the table
      const response = await postPengalamanKerja(this.newWorkExperience);
      this.workExperiences.push({ ...response.data.data });
      // Clear the form fields after adding
      this.newWorkExperience = {
        nama_perusahaan: '',
        lama_bekerja: '',
        jabatan_posisi: '',
        deskripsi_pekerjaan: '',
        uuid: '',
      };
      // Close the modal after saving
      this.$refs.myModalWorkRef.hide();
    },
    async confirmDeleteWorkExperience(workExperience) {
      this.selectedWorkExperience = workExperience;
      // Show a confirmation dialog here and perform deletion based on user confirmation
      // Example: using bootstrap-vue's b-modal for confirmation
      this.$bvModal.msgBoxConfirm('Apakah anda yakin ingin menghapus data ini?', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        hideHeaderClose: false,
        centered: true,
      }).then((value) => {
        if (value) {
          const response = this.deleteWorkExperience(this.selectedWorkExperience);
          if(response){
            // User confirmed deletion
            const index = this.workExperiences.indexOf(this.selectedWorkExperience);
            if (index > -1) {
              this.workExperiences.splice(index, 1);
            }
          }
        }
      });
    },
    async deleteWorkExperience(data){
      const response = await deletePengalamanKerja(data.uuid);
      return response;
    },
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadBerkas(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" ||
          type_file === ".jpg" || type_file === ".JPG" ||
          type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Lihat file',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    validationFormDataDiri() {
      return true
    },
    validationFormDataKeluarga() {
      return true
    },
    validationFormDataPendidikan() {
      return true
    },
  }
};
</script>
